import React from 'react';

const EventAdminDashboard = () => {
  return (
    <div>
       
    </div>
  );
};

export default EventAdminDashboard;